import http from '../../../http/base';

export default ({ API_PATHS }) => ({
    getInsuranceInfo: memberGuids => http.get(API_PATHS.insuranceInfo, { params: { memberGuids } })
});